export default {
  newPassword: null,
  currentPassword: null
}



// WEBPACK FOOTER //
// ./src/shared/models/access/changepasswordmodel.js